<template lang="html">
  <img class="mt-3 mb-3" src="@/assets/logo.png" alt="logo" width="200" />
  <h1 class="title">Heb je interesse in meer informatie over BlueVi?</h1>
  <div class="d-grid gap-2">
    <button
      v-for="answer in answers"
      v-bind:key="answer"
      type="button"
      class="btn btn-lg"
      :class="[
        answerChecked(answer) ? 'btn-info text-light' : 'btn-light text-dark',
      ]"
      @click="addRemoveAnswer(answer)"
    >
      <i class="bi bi-square" v-if="!answerChecked(answer)"></i>
      <i class="bi bi-check-square" v-if="answerChecked(answer)"></i>
      {{ answer }}
    </button>
    <button
      type="button"
      class="btn btn-secondary btn-lg"
      @click="saveQuestionTwo()"
      :disabled="checkedAnswers.length < 1"
    >
      <span>Volgende</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "questionTwoScreen",
  data: () => ({
    answers: ["Ja", "Nee"],
    checkedAnswers: [],
  }),
  computed: {},
  methods: {
    addRemoveAnswer(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        this.checkedAnswers.splice(this.checkedAnswers.indexOf(answer), 1);
      } else {
        this.checkedAnswers = [answer];
      }
    },
    answerChecked(answer) {
      if (this.checkedAnswers.indexOf(answer) !== -1) {
        return true;
      }
      return false;
    },
    saveQuestionTwo() {
      this.$store.commit("setQuestionTwo", this.checkedAnswers);
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 40px;
  color: #4c52ad;
}
.bg-field {
  color: #fdf7ea !important;
}
</style>
